export const ACTION_TYPES = {
    REQUEST_ACCOUNT_OFFICER: 'REQUEST_ACCOUNT_OFFICER',
    RECEIVE_ACCOUNT_OFFICER: 'RECEIVE_ACCOUNT_OFFICER'
};

const initialState = { entities: [], isLoading: false };

export const accountOfficerActions = {
    requestAccountOfficer: () => async (dispatch) => {

        dispatch({ type: ACTION_TYPES.REQUEST_ACCOUNT_OFFICER });

        const url = `api/ao/ddl`;
        const response = await fetch(url);
        const entities = await response.json();

        dispatch({ type: ACTION_TYPES.RECEIVE_ACCOUNT_OFFICER, entities });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case (ACTION_TYPES.REQUEST_ACCOUNT_OFFICER):
            return {
                ...state,
                isLoading: true
            };
        case (ACTION_TYPES.RECEIVE_ACCOUNT_OFFICER):
            return {
                ...state,
                isLoading: false,
                entities: action.entities
            }
        default:
            return state;
    }

};



// WEBPACK FOOTER //
// ./src/store/AccountOfficer.Reducer.js